import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeService {

  constructor() { }

  sameDay(d1: Date, d2: Date) {
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
  }

  sameTime(d1: Date, d2: Date) {
    return this.sameDay(d1, d2) && d1.getHours() === d2.getUTCHours() && d1.getMinutes() === d2.getMinutes();
  }
}
